import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import styles from "../styles/backButton.module.scss";

export default function BackButtonSingle({

    text = "Back",

    steps = -1,

    justify = "flex-start",

    sx = {}

}) {

    const navigate = useNavigate();

    return (
            <Button
                variant="contained"
                size="large"
                className={styles.backSingleBtn}
                sx={sx}
                onClick={() => navigate(steps)}
            >
                {text}

            </Button>


    );

}